<template>
  <div class="brand-ad-read-me">
    <span class="mark"></span>
    <div class="title">
      <div class="bg"></div>
      <span>活动规则</span>
    </div>
    <p class="text">
      1.每个手机号仅可从本活动中领取1次bilibili大会员福利，福利包含大会员3天体验权益或者大会员优惠券。
    </p>
    <p class="text">
      2.您可点击bilibili APP右下角“我的”——“大会员”里查看您领取到的大会员福利！
      其中若您是iOS用户并且领取到大会员满减券，请前往<a class="link" href="//big.bilibili.com/mobile/voucher">big.bilibili.com/mobile/voucher</a>查看~
    </p>
    <p class="text">3.大会员优惠券有效期7天，领取后请尽快使用哦~</p>
    <p class="text">
      4.大会员体验权益将直接激活到您手机号所对应的bilibili账户中，请立即体验哦~
    </p>
  </div>
</template>

<script>
export default {
  name: "read-me",
};
</script>

<style lang="scss">
.brand-ad-read-me {
  padding: 60px 60px 0 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -48px 48px 0px rgba(0, 0, 0, 0.28);
  border-top-left-radius: 48px;
  border-top-right-radius: 48px;
  position: relative;
  margin-top: -30px;
  .mark {
    position: absolute;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-top: 14px solid #fb7299;
    opacity: 0.3;
  }
  .title {
    text-align: center;
    position: relative;
    margin-bottom: 20px;
    .bg {
      width: 632px;
      height: 80px;
      line-height: 80px;
      background: rgba(216, 216, 216, 1);
      box-shadow: 0px 4px 48px 0px rgba(0, 0, 0, 0.34);
      border-radius: 48px;
      opacity: 0.28;
      font-size: 32px;
    }
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fb7299;
      font-size: 32px;
    }
  }
  .text {
    margin: 0 auto;
    width: 600px;
    font-size: 26px;
    font-weight: 400;
    color: rgba(115, 115, 115, 1);
    line-height: 48px;
    user-select: auto;
    .link {
      color: #FB739A;
      user-select: text;
    }
  }
}
</style>
